<template>
  <div class="header-wrapper">
    <div class="flex-ctn flex">
      <div class="nav-logo-wrap flex">
        <a @click="onLogoClick"
          ><img class="nav-logo" src="../assets/image/cl_nav_logo.png"
        /></a>
      </div>
      <el-menu
        :default-active="activeIndex"
        class="handlian-nav"
        mode="horizontal"
      >
        <el-menu-item
          v-for="(item, index) in data"
          :key="index"
          class="nav-item"
        >
          <router-link :to="item.path" active-class="is-selected" exact>
            <!-- exact:严格匹配路由 -->
            <p class="nav-title" v-if="item.type !== '1'">{{ item.title }}</p>
            <p class="user-info-wrapper" v-else>
              <el-submenu index="4">
                <template slot="title" class="flex">
                  <img
                    class="nav-avatar"
                    src="../assets/image/cl_user_avatar.png"
                    v-real-img="user.avatar"
                  />
                  <!-- <span class="nav-nick">{{ user.nickName }}</span> -->
                </template>
                <el-menu-item index="4-1">
                  <!-- <a class="user-link" href="javascript:;" @click="goToUserCenter">我的主页</a> -->
                  <span class="user-link">
                    <router-link :to="item.path">我的主页</router-link>
                  </span>
                </el-menu-item>
                <el-menu-item index="4-2">
                  <span class="out-btn" @click="logoutClick">退出</span>
                </el-menu-item>
              </el-submenu>
              <!-- <el-dropdown>title: "我的"
              <span class="el-dropdown-link">
                {{user.nickName}}
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <span @click="logoutClick">我的主页</span>
                </el-dropdown-item>
                <el-dropdown-item>
                  <span @click="logoutClick">退出</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->
            </p>
          </router-link>
        </el-menu-item>
      </el-menu>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { apiMap } from "../utils/apiMap";
import qs from "qs";
export default {
  name: "navbar",
  props: {
    data: Array,
  },
  data() {
    return {
      activeIndex: "1",
      // errorUserPhoto: 'this.src="' + require('@/assets/image/cl_user_avatar.png') + '"',
    };
  },
  computed: {
    ...mapGetters(["user"]),
    defaultSrc: function() {
      return `src="http://148.70.221.198/pc/image/cl_user_avatar.png"`;
    },
  },
  methods: {
    logoutClick() {
      var loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      if (!loginUser) {
        return false;
      }
      this.sendLogoutSuccessMsg();
      this.$axios({
        baseURL: apiMap["commonUrl"],
        method: apiMap["logout"]["method"],
        url: apiMap["logout"]["url"],
        data: `token=${loginUser.token}`,
      })
        .then(function(response) {
          // console.log(response);
        })
        .catch(function(error) {
          console.log(error);
        });
      tim.logout();
      this.$store.dispatch("resetConversationList");
      this.$store.dispatch("setContactBook");
      this.$store.dispatch("pushAdminNotice");
      sessionStorage.clear();
      localStorage.clear();
      this.$router.push("/login");
    },
    onLogoClick() {
      if (this.$route.path === "/") return;
      this.$router.push({
        path: "/",
      });
    },
    sendLogoutSuccessMsg() {
      var _this = this;
      var loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      var params = {
        token: loginUser.token,
        userId: loginUser.userId.toString(),
        title: "您的帐号在电脑端退出",
        content: "",
        msgType: "500",
      };
      //content: Date.now(),
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["sendAdminMsg"]["method"],
          url: apiMap["sendAdminMsg"]["url"],
          data: qs.stringify(params, { encode: false }),
        })
        .then(function(response) {
          // console.log(response.data.result.data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
.flex-ctn {
  width: 1200px;
  margin: 0 auto;
  justify-content: space-between;
}

.handlian-nav {
  display: flex;
  justify-content: space-between;
  border-bottom: none;
}

.nav-logo-wrap {
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
}

.handlian-nav .nav-item {
  margin: 0 60px;
  padding: 0;
}

.nav-item a {
  display: inline-block;
  text-decoration: none;
  color: #000;
}

.nav-item p {
  font-size: 20px;
}

.nav-item a.is-selected {
  color: #409eff;
}

.nav-item a.is-selected::before {
  content: "";
  display: inline-block;
  position: absolute;
  bottom: 0;
  left: calc(50% - 20px);
  top: 57px;
  width: 40px;
  height: 3px;
  background: #409eff;
}

.nav-item .nav-item-label {
  display: inline-block;
  margin: 15px 20px;
}

.el-dropdown-link i {
  margin-left: 8px;
  margin-bottom: 4px;
  font-size: 25px;
}

.nav-avatar {
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.nav-nick {
  display: inline-block;
  max-width: 210px;
  margin-left: 8px;
  font-size: 17px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-link {
  display: inline-block;
  width: 100%;
}

.user-link a:hover {
  color: #1a70db;
}

.out-btn {
  display: inline-block;
  width: 100%;
  color: #000;
}

.out-btn:hover {
  color: #ff0000;
}

/* .nav-avatar:after{
  content: "";
  display: inline-block;
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url("../assets/image/cl_user_avatar.png") no-repeat;
  background-size: 100% ;
  background-color: #fff;
} */
</style>
